
/* tslint:disable */
const templateData = `
<div class="error-page">
    <div class="error-page-container">
        <div class="error-type">{{::'public.error.403.type' | translate}} | <span>{{::'public.error.403.type.text' | translate}}<span></div>
        <div class="error-title">{{::'public.error.403.title' | translate}} :(</div>
        <div class="error-redirect">{{::'public.error.redirected' | translate}} <go-home-counter></go-home-counter>...</div>
        <a class="icon icon-home home-link" inner-link="/">{{::'public.error.home.btn' | translate}}</a>
    </div>
</div>

`;
export = templateData;
